<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Meeting Style';
                }
            },
            doorColour: {
                required: true
            },
            frameProfile: {
                required: true
            },
            meetingRailOutside: {
                required: false,
                default() {
                    return '';
                }
            }
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.doorColour, this.frameProfile, this.meetingRailOutside);
            },
            url(){
                return '/api/options/' + this.fabricator + '/meeting-rail-colour?door_colour=' + this.doorColour + '&profile=' + this.frameProfile + '&meeting_rail_outside=' + this.meetingRailOutside;
            },
            cache_key(){
                return '_' + this.doorColour + '_' + this.frameProfile + '_' + this.meetingRailOutside;
            },
            panel_required(){
                return true;
            }
        },
        watch: {
            'frameProfile': function (val, oldVal) {
                this.update_options();
            },
            'doorColour': function (val, oldVal) {
                this.update_options();
            },
            'meetingRailOutside': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
